import requireAll from '../requireAll';

import './nv.sdcModule.module';
import './sdc-columns.type';
import './sdc-state';

// the files below don't yet have an index.js so use requireAll()
requireAll(require.context('./dashboards', true, /(?!\.spec)(\S{5}|^\S{1,4})(\.js$|\.ts$)/));
requireAll(require.context('./flux', true, /(?!\.spec)(\S{5}|^\S{1,4})(\.js$|\.ts$)/));
requireAll(require.context('./grid', true, /(?!\.spec)(\S{5}|^\S{1,4})(\.js$|\.ts$)/));
requireAll(require.context('./sdc-state', true, /(?!\.spec)(\S{5}|^\S{1,4})(\.js$|\.ts$)/));
import './new-sdc-grid'; // because this folder has an index.js just import the folder
requireAll(require.context('./sdc-toolbar-menu', true, /(?!\.spec)(\S{5}|^\S{1,4})(\.js$|\.ts$)/));
